// Application settings and features - per APP_ID per deployment
// Production object is the DEFAULT
// If staging exists it will overwrite defaults
//
// Please tag features as such:
// -  No prefix means general feature
// - 'c' stands for Conseil feature
// - 'a' stands for Advisory features

export default {
  wesave: {
    params: {
      appId: 'wesave',
      defaultLocale: 'fr-FR'
    },
    features: {
      production: {
        userAccountsFree: true,
        realEstate: false,
        realEstateEstimator: false,
        aAssistanceUrl: false,
        aFaqUrl: false,
        cAssistanceUrl: 'http://help.wesave.fr/wesave-conseil',
        cDebtRatio: true
      },
      staging: {
        realEstate: true
      }
    }
  },

  liins: {
    params: {
      appId: 'liins',
      defaultLocale: 'fr-FR'
    },
    features: {
      production: {
        userAccountsFree: true,
        realEstate: true,
        realEstateEstimator: false,
        aAssistanceUrl: 'https://wesave.typeform.com/to/LtscVM',
        aFaqUrl: 'https://intercom.help/liins-conseil',
        cAssistanceUrl: false,
        cDebtRatio: false
      },
      staging: {
        realEstate: true
      }
    }
  }
}
